// CompareFace — the thumbnail of a comparison: two app icons, side by side,
// the same size and the same layout on every card, with the name of each under
// its tile and one quiet "vs" between them.
//
// Not netti. The creature is the product's face and it belongs to the person
// looking at it; a comparison card is two products on a shelf, so both sides
// wear their APP ICON — innernet's mark on its tile, the other product's own
// icon on its tile — and neither one is bigger. Same squircle (AppIcon), same
// edge, same drop, so the pair reads as two of the same kind of thing.
//
// No hooks → safe in server and client components, and in the OG image's
// sibling (lib/brand/compareCard) which redraws it for satori.

import AppIcon from "../brand/AppIcon";
import type { CompareSide } from "../../lib/compare/registry";

function Tile({ side, size }: { side: CompareSide; size: number }) {
  const icon = side.icon;
  return (
    <span className="cmp-face__side">
      {"src" in icon ? (
        <AppIcon name={side.name} src={icon.src} size={size} label={side.name} />
      ) : (
        <AppIcon name={icon.brand} size={size} label={side.name} />
      )}
      <span className="cmp-face__name">{side.name}</span>
    </span>
  );
}

export default function CompareFace({
  left,
  right,
  size = 64,
  className,
}: {
  left: CompareSide;
  right: CompareSide;
  /** the tile edge, px — the card and the row pick their own */
  size?: number;
  className?: string;
}) {
  return (
    <span className={["cmp-face", className].filter(Boolean).join(" ")} aria-hidden>
      <Tile side={left} size={size} />
      <span className="cmp-face__vs">vs</span>
      <Tile side={right} size={size} />
    </span>
  );
}
